import { Toast } from '@core/models/toast/toast';
import { IToastState, initialToastState } from './toast.state';
import { TOAST_FLUSH, TOAST_SET } from '../action-types';

export function reducer(state: IToastState = initialToastState(), action: any): IToastState {
    switch (action.type) {
        case TOAST_SET: {
            let toast = action.payload as Toast;
            return { ...state, toast };
        }
        case TOAST_FLUSH: {
            return { ...state, toast: null };
        }
        default:
            return state;
    }
}
